import { AppLogLevel } from './app-log-level';
import { DbBaseModel } from './db-base-model';

export class AppLog extends DbBaseModel {
    logLevel: AppLogLevel;
    logMessage: string;
    moduleName: string;

    constructor(logLevel: AppLogLevel, logMessage: string, moduleName: string) {
        super();
        this.logLevel = logLevel;
        this.logMessage = logMessage;
        this.moduleName = moduleName;
    }
}
